module.exports = __webpack_public_path__ + "static/media/bottle_orange_2.c7e9cf30.png";